import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IntegrationFragment } from './fragments'
import { IIntegration, IEnablePayload, IEnableInput } from './types'
import handleFetchResult from '@utils/handleFetchResult'

const mutateHandler = handleFetchResult<IEnablePayload, IIntegration>({
  handler: (data) => data.createIntegration.integration,
  name: 'Integration',
})

export default function enable(input: IEnableInput): Promise<IIntegration> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation Enable($input: CreateIntegrationInput!) {
    createIntegration(input: $input) {
      integration {
        ...IntegrationFragment
      }
    }
  }
  ${IntegrationFragment}
`
